export const LENDER = () => "LENDER";
export const BORROWER = () => "BORROWER";
export const ADMIN = () => "ADMIN";
export const COMMUNITY = () => "LENDER_COMMUNITY";
